export const ERROR = 'ERROR';
